module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h2 class="coach-title">'+
((__t=( title ))==null?'':_.escape(__t))+
'</h2>\n\n<div class="features">\n	<ul>\n		<li><i class="icons ion-checkmark"></i>Detailed stats insights</li>\n		<li><i class="icons ion-checkmark"></i>Score projections</li>\n		<li><i class="icons ion-checkmark"></i>Break even analysis</li>\n	</ul>\n	<ul>\n		<li><i class="icons ion-checkmark"></i>Venue and opposition stats</li>\n		<li><i class="icons ion-checkmark"></i>Bye detector</li>\n		<li><i class="icons ion-checkmark"></i>And more!</li>\n	</ul>\n</div>';
}
return __p;
};
